<template>
  <v-toolbar
    flat
    color="transparent"
    :class="{ 'reportes-acciones': $slots.default }">
    <v-spacer></v-spacer>
    <slot></slot>
    <custom-button
      v-if="mixValidaScopesActions(1)"
      :label="$vuetify.breakpoint.xs ? '' : 'Nuevo'"
      iconText="mdi-plus"
      aria-label="Nuevo reporte"
      tipo="agregar"
      @click="nuevo">
    </custom-button>
  </v-toolbar>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'ToolBarContratos',
  components: {
    CustomButton,
  },
  data() {
    return {};
  },
  methods: {
    nuevo() {
      this.$emit('nuevoReporte');
    },
  },
};
</script>

<style scoped lang="scss">
.reportes-acciones { height: auto !important; margin-bottom: 16px; }
.reportes-acciones ::v-deep .v-toolbar__content {
  height: auto !important; gap: 12px; flex-wrap: wrap; padding: 12px 0;
}
@media (max-width: 600px) {
  .reportes-acciones ::v-deep .v-toolbar__content > .v-btn { min-height: 44px; }
  .reportes-acciones ::v-deep .v-toolbar__content > .v-btn:first-of-type {
    flex: 1; min-width: 0; height: auto; padding: 10px 8px; font-size: 12px;
  }
  .reportes-acciones ::v-deep .v-toolbar__content > .v-btn:first-of-type .v-btn__content {
    width: 100%; min-width: 0;
  }
  .reportes-acciones ::v-deep .v-toolbar__content > .v-btn:first-of-type .v-icon {
    flex-shrink: 0;
  }
  .reportes-acciones ::v-deep .v-btn span.mx-4 {
    margin: 0 8px !important; white-space: normal; line-height: 1.4; min-width: 0;
  }
  .reportes-acciones ::v-deep .v-toolbar__content > .v-btn:last-of-type {
    min-width: 52px; width: 52px; padding: 0;
  }
  .reportes-acciones ::v-deep .spacer { display: none; }
}

</style>
